import { createSlice } from '@reduxjs/toolkit';

export const positionSchedulingRulesSlice = createSlice({
    name: 'positionSchedulingRules',
    initialState: {
        list: [],
        positionSchedulingRule: null,
        positionForSelect: [],
        globalRules: null,
    },
    reducers: {
        setPositionSchedulingRules: (state, action) => {
            state.list = action.payload;
        },
        setPositionSchedulingRule: (state, action) => {
            state.positionSchedulingRule = action.payload;
        },
        setPositionForSelect: (state, action) => {
            state.positionForSelect = action.payload;
        },
        setGlobalRules: (state, action) => {
            state.globalRules = action.payload;
        }
    }
});

export const { setPositionSchedulingRules, setPositionSchedulingRule, setPositionForSelect, setGlobalRules } = positionSchedulingRulesSlice.actions;
